import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Wrench } from "lucide-react";
import { toast } from "sonner";

export default function AdminLoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await login(email, password); navigate("/admin"); }
    catch (err) { toast.error(err.response?.data?.detail || "Login failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-steel px-4">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm rounded-2xl bg-white p-8 shadow-2xl">
        <div className="flex items-center gap-2 mb-6">
          <span className="grid place-items-center w-10 h-10 rounded-md bg-accent text-steel"><Wrench size={22} strokeWidth={2.5} /></span>
          <div><div className="font-heading font-extrabold text-lg">ACP ONLINE</div>
            <div className="text-[10px] tracking-[0.2em] text-muted-foreground">ADMIN PORTAL</div></div>
        </div>
        <div className="space-y-4">
          <div><Label>Email</Label><Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></div>
          <div><Label>Password</Label><Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required /></div>
          <Button data-testid="login-submit" type="submit" disabled={busy} className="w-full bg-steel text-white hover:bg-steel-light">
            {busy ? "Signing in..." : "Sign In"}
          </Button>
        </div>
      </form>
    </div>
  );
}
